import firebase from '@/firebase';
import { firestoreAction  } from 'vuexfire';
import db from '@/db';
import router from '@/router';

const state = {
  recipe: null,
  user_meals: [],
  meals: [],
  menus: [],
};


const actions = {
  init: firestoreAction(({ bindFirestoreRef }) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // console.log(user)
        // bindFirestoreRef('recipes', db.collection('recipes').where('user_id', '==', user.uid));
        bindFirestoreRef('recipe', db.collection('recipes').doc(router.currentRoute.params.id)).then(() => {
          if (!state.recipe) {
            router.push({ name: 'Home' })
          }
          if (state.recipe.status != 'published' && state.recipe.user_id != user.uid) {
            router.push({ name: 'Home' })
          }
        }); 
        bindFirestoreRef('user_meals', db.collection('meals').where('user_id', '==', user.uid));
        bindFirestoreRef('meals', db.collection('meals'));
        bindFirestoreRef('menus', db.collection('menus').where('user_id', '==', user.uid));
      } else {
        bindFirestoreRef('recipe', db.collection('recipes').doc(router.currentRoute.params.id)).then(() =>{
          if (!state.recipe || state.recipe.status != 'published') {
            router.push({ name: 'Home' })
          }
        });
        bindFirestoreRef('meals', db.collection('meals'));
      }
    });
  }),
};

export default {
  namespaced: true,
  state,
  actions,
};